import { styled, css, u } from '../../shared/theming-sc'
import IconButton from '../icon-button'
import { breakpoints } from '../responsive'

const IconWrapper = styled(IconButton)`
  vertical-align: middle;

  > span {
    display: flex;
    align-items: center;
    font-family: ${u.getFontFamily('knowledge', 'medium')};
  }

  .prev {
    margin-left: ${u.getSpacing('smaller')}px;
  }

  .next {
    margin-right: ${u.getSpacing('smaller')}px;
  }

  &.basicPaginationPrev {
    @media screen and (max-width: ${breakpoints.sm.max}px) {
      float: left;
    }
    @media screen and (min-width: ${breakpoints.md.min}px) and (max-width: ${breakpoints.md.max}px) {
      float: left;
    }
    @media screen and (min-width: ${breakpoints.lg.min}px) {
      margin-right: ${u.getSpacing('large')}px;
    }
  }

  &.basicPaginationNext {
    @media screen and (max-width: ${breakpoints.sm.max}px) {
      float: right;
    }
    @media screen and (min-width: ${breakpoints.md.min}px) and (max-width: ${breakpoints.md.max}px) {
      float: right;
    }
    @media screen and (min-width: ${breakpoints.lg.min}px) {
      margin-left: ${u.getSpacing('large')}px;
    }
  }

  &[disabled] {
    cursor: default;
    position: relative;

    &:after {
      display: block;
      content: "";
      position: absolute;
      background-color: white;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: .5;
    }
  }
`

const ListItem = styled.li`
  display: inline-block;
  vertical-align: middle;
  margin: 0 ${u.getSpacing('smaller')}px;

  ${p => p.isActive && css`
    position: relative;

    &:after {
      content: '\\020';
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
    }

  `}

  ${p => p.isActive && css`
    &:after {
      border-bottom: 2px solid ${u.getColor('primary')};
    }
  `}
`

const PaginationWrapper = styled.nav`
  color: ${u.getColor('greyDark')};
  display: block; //flex;
  align-items: center;
  font-family: ${u.getFontFamily('knowledge', 'medium')};
  font-size: ${u.getFontSize('md')};
  margin-top: ${u.getSpacing('large')}px;
  text-align: center;
  width: 100%;

  ul, ol {
    list-style: none;
    padding: 0;
    display: inline-block;
  }

  & > ul, & > ol {
    display: inline-block; // flex;
    margin-bottom: 0;
    margin-left: -${u.getSpacing('smaller')}px;
    margin-right: -${u.getSpacing('smaller')}px;
  }

  .pagination__tally {
    text-align: center;
    margin: 4px ${u.getSpacing('small')}px 0;
    padding-bottom: ${u.getSpacing('tiny')}px;
    flex-grow: 1;

    ${u.media.greaterThan('sm')`
      display: none;
    `}
  }
`

const ListLink = styled.button`
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  display: block;
  min-width: 10px;
  color: ${u.getColor('greyDark')};
  text-decoration: none;
  border: none;
  background-color: transparent;
  padding: 0 1px;

  &:focus {
    text-decoration: none;
  }
`

const PageList = styled.li`
  text-align: center;
  flex-grow: 1;
  display: none;
  margin: 2px ${u.getSpacing('small')}px 0;
  padding-bottom: ${u.getSpacing('tiny')}px;

  ${u.media.greaterThan('sm')`
    display: block;
  `}

  ul, ol {
    display: inline-block;


    ${u.media.greaterThan('sm')`
      display: inline-block;
    `}
  }

  ul, ol {
    margin: 0;
  }

`

export {
  PageList,
  PaginationWrapper,
  ListItem,
  ListLink,
  IconWrapper
}
